import React, { useState } from 'react';
import { Button } from '@h2/ui';
import { Label } from '@h2/ui';
import { Palette, Check } from 'lucide-react';
import { useConfigurationStore } from '../../stores/useConfigurationStore';

interface TaskTypeColorPickerProps {
  title?: string;
  description?: string;
  hideTitle?: boolean;
}

const presetColors = [
  '#6B7280', // 회색 (기본)
  '#EF4444', // 빨강
  '#F97316', // 주황
  '#EAB308', // 노랑
  '#22C55E', // 초록
  '#3B82F6', // 파랑
  '#8B5CF6', // 보라
  '#EC4899', // 핑크
  '#14B8A6', // 청록
  '#F59E0B', // 호박색
  '#10B981', // 에메랄드
  '#6366F1', // 인디고
];

export const TaskTypeColorPicker: React.FC<TaskTypeColorPickerProps> = ({
  title,
  description,
  hideTitle = false
}) => {
  const { formData, updateField } = useConfigurationStore();
  const selectedColor = formData.color as string || '#6B7280';
  const [showCustomPicker, setShowCustomPicker] = useState(false);

  const handleColorSelect = (color: string) => {
    updateField('color', color);
    setShowCustomPicker(false);
  };

  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium">색상</Label>
      
      <div className="flex items-center space-x-3">
        {/* 선택된 색상 미리보기 */}
        <div 
          className="w-8 h-8 rounded border"
          style={{ backgroundColor: selectedColor }}
        />
        
        {/* 프리셋 색상 */}
        <div className="flex space-x-1">
          {presetColors.slice(0, 6).map((color) => (
            <button
              key={color}
              onClick={() => handleColorSelect(color)}
              className={`w-6 h-6 rounded border-2 ${
                selectedColor === color ? 'border-blue-500' : 'border-gray-200'
              }`}
              style={{ backgroundColor: color }}
              title={color}
            />
          ))}
        </div>
        
        {/* 커스텀 색상 */}
        <input
          type="color"
          value={selectedColor}
          onChange={(e) => handleColorSelect(e.target.value)}
          className="w-8 h-8 border border-input rounded cursor-pointer"
        />
      </div>
    </div>
  );
};
